import React from 'react';

function Button(props) {
  return (
    <button className={`btn ${props.extraClass}`}>{props.buttonText}{props.btnIcon}</button>
  );
}

export default Button;